import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectJobLossHardshipStep = (state) => state.get('jobLossHardshipStep');

const makeSelectJobLossHardshipStep = () => createSelector(
  selectJobLossHardshipStep,
  (stepJobLossHardshipState) => ({
    employerName: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'employerName']),
      ''
    ),
    employerEmail: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'employerEmail']),
      ''
    ),
    address1: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'address1']),
      ''
    ),
    address2: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'address2']),
      ''
    ),
    city: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'city']),
      ''
    ),
    state: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'state']),
      ''
    ),
    province: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'province']),
      ''
    ),
    country: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'country']),
      ''
    ),
    zipOrPostalCode: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'zipOrPostalCode']),
      ''
    ),
    dateOfTerminationRedundancy: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'dateOfTerminationRedundancy']),
      ''
    ),
    howManyYearsDidYouWorkThere: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'howManyYearsDidYouWorkThere']),
      ''
    ),
    describe: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'describe']),
      ''
    ),
    areYouGainfullyEmployedNow: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'areYouGainfullyEmployedNow']),
      ''
    ),
    haveYouBeenEmployedFullTime: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'haveYouBeenEmployedFullTime']),
      ''
    ),
    haveYouFiledForUnemploymentBenefits: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'haveYouFiledForUnemploymentBenefits']),
      ''
    ),
    wasYourEmploymentStatusSeasonal: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'wasYourEmploymentStatusSeasonal']),
      ''
    ),
    wasYourEmploymentStatusRetiredOrResigned: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'wasYourEmploymentStatusRetiredOrResigned']),
      ''
    ),
    haveYouBeenContinuouslyUnemployed: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'haveYouBeenContinuouslyUnemployed']),
      ''
    ),
    newEmployerName: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'newEmployerName']),
      ''
    ),
    newEmployerAddress: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'newEmployerAddress']),
      ''
    ),
    dateYouBeganNewEmployment: mapWithDefault(
      stepJobLossHardshipState,
      () => stepJobLossHardshipState.getIn(['form', 'dateYouBeganNewEmployment']),
      ''
    ),
  })
);

const makeSelectJobLossHardshipStepErrors = () =>
  createSelector(selectJobLossHardshipStep, (state) => state.get('errors'));

export {
  makeSelectJobLossHardshipStep,
  makeSelectJobLossHardshipStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.JobLossHardshipStep/selectors.js